/**
 * Check if a value is a Date
 * @param {*} val - Value to test
 * @returns {boolean}
 */
const isValidDate = val => {
  return val instanceof Date && !isNaN(val)
}

module.exports = isValidDate
